var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eye Hide"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x8E\xA8 Color",
    d: "M21.7803 2.21967C22.0466 2.48594 22.0708 2.9026 21.8529 3.19621L21.7803 3.28033L17.7458 7.3149C19.6678 8.66437 21.1042 10.6799 21.7011 13.0644C21.8017 13.4662 21.5575 13.8735 21.1557 13.9741C20.7539 14.0746 20.3466 13.8305 20.246 13.4286C19.7165 11.3135 18.4089 9.53947 16.6658 8.39452L14.8562 10.2043C15.5637 10.9258 16 11.9143 16 13.0046C16 15.2138 14.2091 17.0046 12 17.0046C10.9096 17.0046 9.92116 16.5683 9.19963 15.8608L3.28033 21.7803C2.98744 22.0732 2.51256 22.0732 2.21967 21.7803C1.9534 21.5141 1.9292 21.0974 2.14705 20.8038L2.21967 20.7197L8.33321 14.6055L8.332 14.604L9.53207 13.4061L12.402 10.5368L12.4 10.536L15.2812 7.65782L15.28 7.656L16.4133 6.52549L20.7197 2.21967C21.0126 1.92678 21.4874 1.92678 21.7803 2.21967ZM13.7959 11.2655L10.2608 14.8006C10.7108 15.2364 11.3241 15.5046 12 15.5046C13.3807 15.5046 14.5 14.3853 14.5 13.0046C14.5 12.3287 14.2318 11.7154 13.7959 11.2655ZM12 5.5C13.0003 5.5 13.9709 5.64807 14.8889 5.925L13.6519 7.16119C13.1161 7.05532 12.5636 7 12 7C8.07693 7 4.6901 9.68026 3.75286 13.4332C3.6525 13.835 3.24535 14.0794 2.84348 13.9791C2.44161 13.8787 2.19719 13.4716 2.29755 13.0697C3.40065 8.65272 7.38448 5.5 12 5.5ZM11.8053 9.00928L8.004 12.81C8.10575 10.7531 9.75276 9.10764 11.8053 9.00928Z",
    fill: "#212121"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeHide);
export default __webpack_public_path__ + "static/media/eye_hide.4074511e31329ada8e5a0b37a97b978d.svg";
export { ForwardRef as ReactComponent };